
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl";
import cookies from "@/assets/scripts/stores/store-cookies";

export default {
  name: "MapBox",

  props: {
    markers: { type: Array, default: () => [] }
  },

  computed: {
    mapboxConsent() {
      return cookies.state.mapboxConsent;
    }
  },

  watch: {
    markers(value, old) {
      this.addMarkers(value);
    },

    mapboxConsent(value) {
      if (value && !this.map) {
        this.$nextTick(() => {
          this.createMap();
        });
      }
    }
  },

  mounted() {
    if (this.mapboxConsent) {
      this.$nextTick(() => {
        this.createMap();
      });
    }
  },

  methods: {

    createMap() {
      try {
        mapboxgl.accessToken = process.env.MAPBOX_ACCESS_TOKEN;

        this.map = new mapboxgl.Map({
          container: this.$refs.map,
          style: "mapbox://styles/mybeers/ckz9tytg0000914nupbn8sais",
          center: [2.473546053321485, 46.618170346335916],
          zoom: (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 3.8 : 5),
          cooperativeGestures: {
            twoFingerPan: true
          },
          locale: {
            "ScrollZoomBlocker.CtrlMessage": "Utiliser ctrl + défilement pour zoomer sur la carte",
            "ScrollZoomBlocker.CmdMessage": "Utiliser ⌘ + défilement pour zoomer sur la carte",
            "TouchPanBlocker.Message": "Utiliser deux doigts pour déplacer la carte",
          },
        });
      } catch (err) {
        // eslint-disable-next-line
        console.error("Error map", err);
      }

      if (!this.map) return;

      this.addMarkers(this.markers);

      this.addHStoreListButton(this.map);

      this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }));
      this.map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
          zoom: 16
        },
        showAccuracyCircle: true,
        trackUserLocation: false,
        showUserHeading: true
      }));

      this.map.dragRotate.disable();
      this.map.touchZoomRotate.disableRotation();

      setTimeout(() => {
        this.$emit("ready");
      }, 500);
    },


    addHStoreListButton(map) {
      class StoreListButton {
        onAdd(map) {
          const div = document.createElement("div");
          div.className = "store-panel__button_spacer";

          return div;
        }
      }

      map.addControl(new StoreListButton(), "top-right");
    },

    addMarkers(markers) {
      if (!this.mapboxConsent || !markers || markers.length <= 0) return;

      if (this.mapBoxMarkers && this.mapBoxMarkers.length) {
        this.mapBoxMarkers.forEach((marker) => marker.remove());
      }

      this.mapBoxMarkers = [];
      markers.forEach(this.createMarker);
    },

    createMarker(data) {
      const el = document.createElement(data.href ? "a" : "div");
      el.className = "marker";
      el.style.backgroundImage = data.disabled ? `url(/images/marker-grey.svg)` : `url(/images/marker.svg)`;
      el.style.backgroundSize = "100%";
      el.style.width = "29px";
      el.style.height = "36px";
      el.style.cursor = "pointer";

      if (data.href) {
        el.setAttribute("href", data.href);
      } else {
        el.data = data;
        el.addEventListener("click", this.onClickPlace);
      }

      this.mapBoxMarkers.push(
        new mapboxgl.Marker(el).setLngLat(data.coordinates).addTo(this.map)
      );
    },

    onClickPlace(e) {
      const data = e.currentTarget.data;
      if (!data) return;

      this.openPopupStore(data);
    },

    zoomIn(coordinates) {
      if (this.map && coordinates && coordinates.length >= 2) {
        this.map.flyTo({
          center: coordinates,
          zoom: 10,
          speed: 2
        });
      }
    },

    openPopupStore(data) {
      const { coordinates, name, city, zipcode, page, googleData } = data;
      const htmlContent = `<div class="map-popup">
      <p class="map-popup__name"><span class="text-red">${name} </span>/&nbsp;${city}</p>
      <p class="map-popup__zipcode">code&nbsp;postal&nbsp;: ${zipcode}</p>
      <a href="${page}" class="map-popup__link map-popup__link--page">Voir la fiche</a>
      <a href="${googleData.mapUrl}" style="${!googleData.mapUrl ? "display:none" : ""}"
        class="map-popup__link map-popup__link--google"
        target="_blank">Voir sur Google</a>
      </div>`;

      setTimeout(() => {
        const popup = new mapboxgl.Popup();
        popup.setLngLat(coordinates).setHTML(htmlContent).addTo(this.map);
      }, 100);
    },

    requestConsent() {
      cookies.mutations.requestConsent("MapBox", () => {
        this.createMap();
      });
    }
  }
};
